import { request } from "../request";

export default {
    getAllByAppID: ({ app_id, type }) => request(`notifications/show_notification/${app_id}${type ? '?type=' + type : ''}`, "GET"),
    getUserCountByAppID: ({ app_id }) => request(`notifications/show_user_count/${app_id}`, "GET"),
    sendNotificationApp: (params) => request(`notifications/send_notification/${params.app_id}`, "POST", params.body),
    sendScheduleNotificationApp: (params) => request(`notifications/send_schedule_notification/${params.app_id}`, "POST", params.body),

    // Insights endpoints
    getInsights: ({ app_id }) => request(`notifications/insights/${app_id}`, "GET"),
    getAppInsights: ({ app_id }) => request(`notifications/insights/${app_id}/app`, "GET"),
    getNotificationInsights: ({ app_id, notification_id }) => request(`notifications/insights/${app_id}/notification/${notification_id}`, "GET"),
};